class CartRecommendations extends HTMLElement {

	constructor(){
		super();
		this.generateRecommendations();
	}

	generateRecommendations(){
		const cartItems = document.getElementById('AjaxCartForm').querySelectorAll('[data-js-cart-item]');
		if ( cartItems.length > 0 ) {
			// KN: solange der kostenlose Versand nicht erreicht ist, Bestseller zum Auffüllen zeigen,
			// sonst (oder bei Fehler) die normalen Empfehlungen.
			const requestId = this._knRequestId = (this._knRequestId || 0) + 1;
			const root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
			fetch(`${root}?section_id=kn-cart-fillup`)
				.then(response => response.ok ? response.text() : '')
				.then(text => {
					if ( requestId !== this._knRequestId ) return;
					const fillup = new DOMParser()
						.parseFromString(text, 'text/html')
						.querySelector('[data-js-kn-fillup]');
					if ( fillup && fillup.querySelectorAll('[data-js-product-item]').length > 0 ) {
						this.innerHTML = fillup.outerHTML;
					} else {
						this.knDefaultRecommendations(cartItems, requestId);
					}
				})
				.catch(() => { this.knDefaultRecommendations(cartItems, requestId); });
		}
	}

	knDefaultRecommendations(cartItems, requestId){
		fetch(`${KROWN.settings.routes.product_recommendations_url}?section_id=${this.dataset.section}&product_id=${cartItems[0].dataset.productId}&limit=${this.dataset.limit}`)
			.then(response => response.text())
			.then(text => {
				if ( requestId !== this._knRequestId ) return;
				const innerHTML = new DOMParser()
					.parseFromString(text, 'text/html')
					.querySelector('[data-js-cart-recommendations-performed]');
				if ( innerHTML && innerHTML.querySelectorAll('[data-js-product-item]').length > 0 ) {
					this.innerHTML = innerHTML.innerHTML;
				}
			})
	}
}
customElements.define('cart-recommendations', CartRecommendations);